import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Col,  Form } from 'antd';
import { SPAN_FULL } from '../../../../../../../styles/constants';
import { showFileMappingWizardAddFieldFunctionPadFormChange, onChangeConcat } from '../../actions';
import ConcatForm from './ConcatForm';
import FormList from '../../../../../../../components/form-list';
import _ from "lodash";

const mapStateToProps = state => ({
  csvHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,
  ConcatFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.ConcatFormData
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(showFileMappingWizardAddFieldFunctionPadFormChange(fields)),
  onFormChange: fields => dispatch(onChangeConcat(fields)),
});

const mapPropsToFields = ({ConcatFormData}) => ({
  selectListValue: Form.createFormField({value: ConcatFormData !== null ? ConcatFormData.selectListValue : null}),
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardConcatWizard = ({
                                      t,
                                      ConcatFormData,
                                      onFormChange
                                    }) => {
                          
  return (
    
    <Fragment>
        <Col span={SPAN_FULL}>
        <FormList
          compact
          notCollapsable
          values={ConcatFormData.selectListValue}
          Component={ConcatForm}
          newItem={{
            selectValue: null
          }}
          onChange={onFormChange}
          addItemLabel={t('data.fileMapping.addField.functionWizard.addColumn.label')}
          removeItemLabel={t('data.fileMapping.addField.functionWizard.removeColumn.label')}
        />
        </Col>
    </Fragment>
);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(FileMappingWizardConcatWizard);